import { setCookie } from '@bibliocommons/utils-browser';

export default function redirectMiddleware() {
  return next => action => {
    const url = action.payload ? action.payload.forceRedirectURL : action.forceRedirectURL;
    if (url && __CLIENT__) {
      const PRE_LOGIN_URL_COOKIE = 'pre_login_url';
      setCookie(PRE_LOGIN_URL_COOKIE, window.location.href, { path: '/' });
      window.location.href = url;
    } else {
      next(action);
    }
  };
}
